import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../../auth/stores/authStore';
import { getSiteBurndown } from '../api/sitesApi';
import { sitesKeys } from './useSites';

export function useSiteBurndown(siteId: number | null) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: sitesKeys.burndown(siteId || 0),
    queryFn: () => getSiteBurndown(siteId!),
    enabled: isAuthenticated && !!siteId,
    staleTime: 60 * 1000,
  });
}
